import type { UserProfile } from "../../services/backendTypes";
import { type OnboardingState, DEFAULT_MEAL_TIMES, determineWeeklyGoal } from "../../slices/onboardingSlice";
import { MacrosPreferenceEnum, WeeklyGoalEnum } from "../../types";

// eslint-disable-next-line import/prefer-default-export
export function createOnboardingState(userProfile: UserProfile): OnboardingState {
  const DEFAULT_HEIGHT = 170;
  const DEFAULT_WEIGHT = 70;
  const DEFAULT_GOAL_WEIGHT = 65;
  const DEFAULT_WEEKLY_GOAL = WeeklyGoalEnum.LOSE_0_25_KG_PER_WEEK;

  const weeklyGoal = userProfile.goal_weekly_change_in_kg
    ? determineWeeklyGoal(userProfile.goal_weekly_change_in_kg)
    : DEFAULT_WEEKLY_GOAL;

  return {
    goal: userProfile.main_goal || "LOSE_WEIGHT",
    activityLevel: userProfile.activity,
    biometricData: {
      age: userProfile.age || 25,
      gender: userProfile.gender,
    },
    physicalStats: {
      heightInCm: userProfile.height_in_cm || DEFAULT_HEIGHT,
      weightInKg: userProfile.weight || DEFAULT_WEIGHT,
      goalWeight: userProfile.goal_weight_in_kg || DEFAULT_GOAL_WEIGHT,
    },
    weeklyGoal,
    dietPreferences: {
      dietType: MacrosPreferenceEnum.RECOMMENDED,
      intolerances: [],
      ingredientDislikes: [],
      mealTimes: DEFAULT_MEAL_TIMES,
    },
    preferences: {
      usesImperialUnitsForRecipes: userProfile.uses_imperial_measurements_for_recipes || false,
      usesImperialUnitsForHeight: userProfile.uses_imperial_measurements_for_height || false,
      personalWeightUnit: userProfile.personal_weight_unit || "KILOGRAMS",
    },
    menstrualCycle: {
      lastMenstrualPeriodStartDate: userProfile.last_menstrual_period_start_date,
      menstrualCycleLength: userProfile.menstrual_cycle_length,
    },
  };
}
